import React, { useEffect, useState } from "react";
import Basic from "./Main/Basic/Basic";
import More from "./Main/More/More";
import Side from "./Side/Side";
import { motion } from "framer-motion";

export default function Profile() {
  const [tab, setTab] = useState("basic");
  const [isLoading, setIsLoading] = useState(true);
  const lazyDummy = () => {
    setTimeout(() => {
      setIsLoading(false);
    }, 2000);
  };
  useEffect(() => {
    lazyDummy();
  }, []);
  return (
    <div className="layout">
      <div className="auto__container">
        {isLoading ? <h3 className="placeholder"> </h3> : <h3>My profile</h3>}
        <div className="layout__inner box">
          {isLoading ? (
            <div className="layoutSide">
              <div className="layoutSide__btn placeholder"></div>
              <div className="layoutSide__btn placeholder"></div>
            </div>
          ) : (
            <Side tab={tab} setTab={setTab} />
          )}
          {isLoading ? (
            <div className="layoutMain placeholder"></div>
          ) : (
            <>
              {tab === "basic" && (
                <motion.div
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.2 }}
                  exit={{ opacity: 0, y: 10 }}
                  className="layoutMain"
                >
                  <Basic />
                </motion.div>
              )}
              {tab === "more" && (
                <motion.div
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.2 }}
                  exit={{ opacity: 0, y: 10 }}
                  className="layoutMain"
                >
                  <More />
                </motion.div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}
